import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import Small from 'UIComponents/elements/Small';
import UICheckbox from 'UIComponents/input/UICheckbox';
import styled from '../../../components/Theme';
import { FilterQuery, Goal, Product } from '../../../consts';
import { useFilter, useJSONFilter } from '../../../utils/hooks';
import CompanySelect from '../../company/components/CompanySelect';
import GeolocationSelect from '../../geolocation/components/GeolocationSelect';
import IndustrySelect from '../../industry/components/IndustrySelect';
const FilterGroup = styled.div.withConfig({
  displayName: "DirectoryFilters__FilterGroup",
  componentId: "sc-1tt2xw5-0"
})(["margin-bottom:16px;"]);
const SmallDemibold = styled(Small).withConfig({
  displayName: "DirectoryFilters__SmallDemibold",
  componentId: "sc-1tt2xw5-1"
})(["font-weight:500;"]);

const DirectoryFilters = () => {
  const {
    selectedItems: selectedProducts,
    handleToggle: handleToggleProducts,
    handleClear: handleClearProducts
  } = useFilter(FilterQuery.products);
  const {
    selectedItems: selectedGoals,
    handleToggle: handleToggleGoals,
    handleClear: handleClearGoals
  } = useFilter(FilterQuery.goals);
  const {
    selectedObjects: selectedLocations,
    handleReplace: handleReplaceLocation,
    handleClear: handleClearLocation
  } = useJSONFilter(FilterQuery.location);
  const {
    selectedObjects: selectedIndustries,
    handleReplace: handleReplaceIndustry,
    handleClear: handleClearIndustry
  } = useJSONFilter(FilterQuery.industry);
  const {
    selectedObjects: selectedCompanies,
    handleReplace: handleReplaceCompany,
    handleClear: handleClearCompany
  } = useJSONFilter(FilterQuery.company);
  const handleGeolocationChange = useCallback(location => {
    handleClearLocation();

    if (location) {
      handleReplaceLocation(location);
    }
  }, [handleReplaceLocation, handleClearLocation]);
  const handleIndustryChange = useCallback(industry => {
    handleClearIndustry();

    if (industry) {
      handleReplaceIndustry(industry);
    }
  }, [handleReplaceIndustry, handleClearIndustry]);
  const handleCompanyChange = useCallback(company => {
    handleClearCompany();

    if (company) {
      handleReplaceCompany(company);
    }
  }, [handleClearCompany, handleReplaceCompany]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(FilterGroup, {
      "data-test-id": "products-used-filters",
      children: [/*#__PURE__*/_jsx(SmallDemibold, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.filters.productsUsed"
        })
      }), /*#__PURE__*/_jsx(UICheckbox, {
        size: "sm",
        checked: !selectedProducts.length,
        onChange: handleClearProducts,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.filters.anyProduct"
        })
      }), Object.values(Product).map(product => /*#__PURE__*/_jsx(UICheckbox, {
        "data-test-id": "product-checkbox",
        "data-meta": product,
        size: "sm",
        checked: selectedProducts.includes(product),
        onChange: () => handleToggleProducts(product),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `connectDotCom.hubs.${product}`
        })
      }, product))]
    }), /*#__PURE__*/_jsxs(FilterGroup, {
      "data-test-id": "goal-type-filters",
      children: [/*#__PURE__*/_jsx(SmallDemibold, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.filters.goalType"
        })
      }), /*#__PURE__*/_jsx(UICheckbox, {
        size: "sm",
        checked: !selectedGoals.length,
        onChange: handleClearGoals,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.filters.anyGoal"
        })
      }), Object.values(Goal).map(goal => /*#__PURE__*/_jsx(UICheckbox, {
        "data-test-id": "goal-checkbox",
        "data-meta": goal,
        size: "sm",
        checked: selectedGoals.includes(goal),
        onChange: () => handleToggleGoals(goal),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `connectDotCom.goals.${goal}`
        })
      }, goal))]
    }), /*#__PURE__*/_jsx(FilterGroup, {
      "data-test-id": "location-filter",
      children: /*#__PURE__*/_jsxs(SmallDemibold, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.filters.location"
        }), /*#__PURE__*/_jsx(GeolocationSelect, {
          onChange: handleGeolocationChange,
          placeholder: I18n.text('connectDotCom.chooseLocation'),
          value: selectedLocations.length ? selectedLocations[0] : null
        })]
      })
    }), /*#__PURE__*/_jsx(FilterGroup, {
      "data-test-id": "company-filter",
      children: /*#__PURE__*/_jsxs(SmallDemibold, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.filters.company"
        }), /*#__PURE__*/_jsx(CompanySelect, {
          onChange: handleCompanyChange,
          placeholder: I18n.text('connectDotCom.chooseCompany'),
          value: selectedCompanies.length ? selectedCompanies[0] : null
        })]
      })
    }), /*#__PURE__*/_jsx(FilterGroup, {
      "data-test-id": "industry-filter",
      children: /*#__PURE__*/_jsxs(SmallDemibold, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.filters.industry"
        }), /*#__PURE__*/_jsx(IndustrySelect, {
          onChange: handleIndustryChange,
          placeholder: I18n.text('connectDotCom.chooseIndustry'),
          value: selectedIndustries.length ? selectedIndustries[0] : null
        })]
      })
    })]
  });
};

export default DirectoryFilters;